<template>
  <v-card
    class="my-3"    
    style="background-color: rgb(var(--v-theme-contained))"
    variant="elevated"
    elevation="2"
    width="100%"
    @click="showAttributeModal = true"
  >
    <v-card-text style="padding-bottom: 0px; padding-top: 4px; padding-left: 8px;">
      {{ bubbleItem.path.join(" / ") }}
    </v-card-text>
    <v-card-title style="padding-bottom: 0px; padding-top: 0px;">{{bubbleItem.name}}</v-card-title>
    <v-card-text style="padding-bottom: 8px;">
      <!-- hide symbol text to reload data on change inside modal -->
      <SymbolText :id="bubbleItem.id" styled :color="bubbleItem.color" :updating-comp="!showAttributeModal" />
    </v-card-text>
  </v-card>
  <attribute-modal
    :show="showAttributeModal"
    :attribute-id="bubbleItem.id"
    @set="$emit('render')"
    @done="showAttributeModal = false"
  />
</template>

<script setup lang="ts">
import { computed, onMounted, ref, onUnmounted, watch } from "vue";
import type { BubblyItem } from "@lr-notitia/bubbly-d3";
import { useGraphStore } from "../../../../store/graph";
import AttributeModal from "../AttributeModal.vue";
import { DescriptorDatatype } from "@lr-notitia/notitia-operator/schemas";
import { useSymbolsStore } from "../../../../store/symbols";
import SymbolText from "./SymbolText.vue";
import { RefSymbol } from "@vue/reactivity";

defineProps<{
  bubbleItem: BubblyItem & {path:string[]}
}>();
defineEmits(["render"])

const showAttributeModal = ref<boolean>(false);
</script>